export const PRIMARY_LIGHT = '#7beec0';
export const PRIMARY_MAIN = '#45bb90';
export const PRIMARY_DARK = '#008a62';
export const PRIMARY_CONTRAST_TEXT = '#000000';

export const SECONDARY_LIGHT = '#d4fffd';
export const SECONDARY_MAIN = '#a1f4ca';
export const SECONDARY_DARK = '#70c199';
export const SECONDARY_CONTRAST_TEXT = '#000000';